import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    logInData: null,
    sessionErr: false,
    form: {
      notification: {
        value: false,
        type: null,
        message: null,
      },
      loading: null,
      state: 'light-green darken-1',
    },
    sessionData: {
      api_token: null,
      role: null,
    },
    calendar: [],
    panelYear: null,
    panelMonth: null,
    loadedCalendar: false,
    cabins: [],
    reservas: null,
    loadedReservas: false,
    cabinRes: null,
    cabin: null,
    activeReservation: null,
    voucherDetails: null,
    loadedActive: false,
    api_token: null,
    role: null,
    currency: null,
    currencyDate: null,
    activeMonth: null,
    activeYear: null,
    prevRoute: null,
    activeExpansionPanel: {
      year: null,
      month: null,
    },
    currencyLoaded: null,
  },
  mutations: {
    toggleDrawer(state) {
      // eslint-disable-next-line
      state.drawer = !state.drawer;
    },
    closeDrawer(state) {
      // eslint-disable-next-line
      state.drawer = false;
    },
    setLogInData(state, payload) {
      // eslint-disable-next-line
      state.logInData = payload
    },
    setFormNotification(state, payload) {
      // eslint-disable-next-line
      state.form.notification = payload;
    },
    setCalendar(state) {
      const startingYear = 2018;
      const lastYear = new Date().getFullYear() + 1;
      // eslint-disable-next-line
      for (let i = startingYear; i <= lastYear; i++) {
        state.calendar.push({
          id: i,
          months: [],
        });
      }
      state.calendar.forEach((year) => {
        // eslint-disable-next-line
        for (let i = 0; i < 12; i++) {
          year.months.push({
            id: i,
            headers: [
            ],
            cabins: [],
          });
        }
        year.months.forEach((month, index) => {
          const lastDay = new Date(year.id, (index + 1), 0).getDate();
          // eslint-disable-next-line
          for (let i = 0; i < 7; i++) {
            month.cabins.push([]);
          }
          month.cabins.forEach((cabin, cabinIndex) => {
            // eslint-disable-next-line
            for (let i = 0; i < lastDay; i++) {
              cabin.push(false);
              if (cabinIndex === 0) {
                let day = new Date(year.id, month.id, i + 1).getDay();
                switch (day) {
                  case 0:
                    day = 'Dom';
                    break;
                  case 1:
                    day = 'Lun';
                    break;
                  case 2:
                    day = 'Mar';
                    break;
                  case 3:
                    day = 'Mie';
                    break;
                  case 4:
                    day = 'Jue';
                    break;
                  case 5:
                    day = 'Vie';
                    break;
                  case 6:
                    day = 'Sab';
                    break;
                  default: return '';
                }
                month.headers.push({
                  text: `${day} ${i + 1}`,
                  align: 'center',
                  sortable: false,
                  value: `${i + 1}`,
                });
              }
            }
            return '';
          });
        });
      });
    },
    setLoadedCalendar(state) {
      // eslint-disable-next-line
      state.loadedCalendar = true;
    },
    async setActiveReservation(state, payload) {
      try {
        const details = await axios.get('http://aplicacion.colinadelmanzano.com.ar/api/public/api/voucher');
        // eslint-disable-next-line
        state.voucherDetails = details.data;
        // eslint-disable-next-line
        state.activeReservation = state.reservas.filter(reserva => reserva.id === payload);
        if (state.activeReservation[0]) {
          // eslint-disable-next-line
          state.activeReservation = state.activeReservation[0];
        }
        // eslint-disable-next-line
        state.loadedActive = true;
      } catch (e) {
        throw new Error(e);
      }
    },
    setPanel(state, payload) {
      switch (payload.collection) {
        case 'years':
          // eslint-disable-next-line
          state.panelYear = payload.id;
          break;
        case 'months':
          // eslint-disable-next-line
          state.panelMonth = payload.id;
          break;
        default:
          break;
      }
    },
    setPreviousRoute(state, payload) {
      // eslint-disable-next-line
      state.prevRoute = payload;
    },
    setActiveExpansionPanel(state, payload) {
      // eslint-disable-next-line
      state.activeExpansionPanel = {
        year: null,
        month: null,
      };
      // eslint-disable-next-line
      state.activeExpansionPanel = payload;
    },
  },
  actions: {
    async logIn(context, payload) {
      // eslint-disable-next-line
      this.state.form.loading = true;
      try {
        await context.commit('setLogInData', payload);
        const response = await axios.post('http://aplicacion.colinadelmanzano.com.ar/api/public/api/loginlogin', {
          email: context.state.logInData.email,
          password: context.state.logInData.password,
        });
        window.localStorage.setItem('api_token', response.data.api_token);
        window.localStorage.setItem('role', response.data.role);
        // eslint-disable-next-line
        context.state.form.loading = false;
        context.dispatch('setSession');
        // this.$router.go();
        // vm.$forceUpdate()
        // // router.push('/menu');
      } catch (e) {
        // eslint-disable-next-line
        this.state.form.loading = false;
        if (e.response.status === 401) {
          context.commit('setFormNotification', {
            value: true,
            type: 'error',
            message: 'El usuario o la contraseña son incorrectos',
          });
        } else {
          context.commit('setFormNotification', {
            value: true,
            type: 'error',
            message: `Hubo un problema con el formulario (Código de error: ${e.response.status}).`,
          });
        }
      }
    },
    setCalendar(context) {
      const startingYear = 2018;
      const lastYear = new Date().getFullYear() + 2;
      const totalMonths = 12;
      for (let year = startingYear; year <= lastYear; year += 1) {
        context.state.calendar.push({
          id: year,
          months: [],
        });
      }
      context.state.calendar.forEach((year) => {
        for (let month = 0; month < totalMonths; month += 1) {
          year.months.push({
            id: month,
            rescount: 0,
            cabins: [],
            totalDays: 0,
            daysArr: [],
          });
          const totalDays = new Date(year.id, month + 1, 0).getDate();
          // eslint-disable-next-line
          year.months[month].totalDays = totalDays;
          for (let cabin = 0; cabin < 7; cabin += 1) {
            year.months[month].cabins.push({
              id: cabin,
              reservas: [],
            });
          }
        }
        year.months.forEach((month) => {
          let currentDay = new Date(`${month.id + 1}/01/${year.id}`);
          currentDay = currentDay.getDay();
          for (let day = 0; day < month.totalDays; day += 1) {
            month.daysArr.push(currentDay);
            if (currentDay < 6) {
              currentDay += 1;
            } else {
              currentDay = 0;
            }
          }
        });
      });
    },
    setDays(context, payload) {
      // debugger;
      const arrival = new Date(payload.arrival);
      let day = arrival.getDate();
      let yearPos = arrival.getFullYear() - 2018;
      let month = arrival.getMonth();
      let { totalDays } = payload;
      const lastDayOfMonth = context.state.calendar[yearPos].months[month].totalDays;
      const cabin = payload.cabin - 1;
      let remainingDays = 0;
      if (day + totalDays > lastDayOfMonth) {
        // remainingDays = totalDays - (lastDayOfMonth - day + 1);
        remainingDays = (totalDays - 1) - (lastDayOfMonth - day);
        totalDays = lastDayOfMonth - day;
        // eslint-disable-next-line
        context.state.calendar[yearPos].months[month].rescount += 1;
        // eslint-disable-next-line
        context.state.calendar[yearPos].months[month].cabins[cabin].reservas.push({
          id: payload.id,
          cabin,
          day,
          totalDays,
          breakfast: payload.breakfast,
          name: {
            firstname: payload.name.firstname,
            lastname: payload.name.lastname,
          },
          guests: payload.guests,
          origin: payload.origin,
        });
        day = 1;
        if (month < 11) {
          month += 1;
        } else {
          yearPos += 1;
          month = 0;
        }
        if (remainingDays > 0) {
          context.dispatch('setDays', {
            arrival: `${month + 1}/${day}/${yearPos + 2018}`,
            cabin: payload.cabin,
            totalDays: remainingDays,
            id: payload.id,
            name: payload.name,
            breakfast: payload.breakfast,
            guests: payload.guests,
            origin: payload.origin,
          });
        }
      } else {
        // eslint-disable-next-line
        context.state.calendar[yearPos].months[month].rescount += 1;
        context.state.calendar[yearPos].months[month].cabins[cabin].reservas.push({
          id: payload.id,
          cabin,
          day,
          totalDays: totalDays - 1,
          breakfast: payload.breakfast,
          name: {
            firstname: payload.name.firstname,
            lastname: payload.name.lastname,
          },
          guests: payload.guests,
          origin: payload.origin,
        });
      }
    },
    async setCabins(context, payload) {
      try {
        let cabins = await axios.get(payload);
        cabins = cabins.data;
        // eslint-disable-next-line
        context.state.cabins = cabins;
        for (let i = 0; i < context.state.cabins.length; i += 1) {
          // eslint-disable-next-line
          context.state.cabins[i].resCount = 0;
        }
      } catch (e) {
        if (e.response.status === 401) {
          context.dispatch('goBackToLogin', 'sessionErr');
        }
        throw new Error(e);
      }
    },
    async setReservas(context, payload) {
      try {
        let reservas = await axios.get(payload);
        reservas = reservas.data;
        reservas = reservas.filter(reserva => reserva.id);
        // eslint-disable-next-line
        context.state.reservas = reservas;
        if (context.state.cabins) {
          context.state.reservas.forEach((reserva) => {
            // eslint-disable-next-line
            context.state.cabins[(reserva.reservation_data.cabin - 1)].resCount += 1;
          });
        }
        // eslint-disable-next-line
        context.state.loadedReservas = true;
      } catch (e) {
        if (e.response.status === 401) {
          context.dispatch('goBackToLogin', 'sessionErr');
        }
        throw new Error(e);
      }
    },
    goBackToLogin(context, action) {
      // debugger;
      switch (action) {
        case 'sessionErr':
          // eslint-disable-next-line
          context.state.sessionErr = true;
          break;
        case 'signOut':
          // eslint-disable-next-line
          context.dispatch('signOut');
          // eslint-disable-next-line
          context.state.sessionErr = false;
          break;
        default:
          break;
      }
    },
    signOut(context) {
      axios.post('http://sd-863073-h00104.ferozo.net/api/logout');
      window.localStorage.removeItem('api_token');
      window.localStorage.removeItem('role');
      context.dispatch('setSession');
      router.push('/');
    },
    // eslint-disable-next-line
    async setSession(context) {
      // eslint-disable-next-line
      context.state.sessionData.api_token = await window.localStorage.getItem('api_token');
      // eslint-disable-next-line
      context.state.sessionData.role = await window.localStorage.getItem('role');
    },
    async getCurrency(context) {
      try {
        const response = await axios.get('http://apilayer.net/api/live?access_key=f0d913476d812ff33f959eae7bc42d93&currencies=ARS&format=1');
        // eslint-disable-next-line
        context.state.currency = response.data.quotes.USDARS;
        // eslint-disable-next-line
        context.state.currencyLoaded = true;
        let date = `${response.data.timestamp}000`;
        date = parseInt(date, 10);
        date = new Date(date);
        date = date.toLocaleDateString('es-AR', {
          weekday: 'long',
          // year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        });
        // eslint-disable-next-line
        context.state.currencyDate = date;
      } catch (e) {
        // eslint-disable-next-line
        context.state.currency = 'Servicio temporalmente no disponible';
      }
    },
  },
});
